<!-- ===================================================
     post-editor.component.html - ARCHIVO SEPARADO
     =================================================== -->

<!-- Template que será renderizado en el overlay (fuera del árbol DOM) -->
<ng-template #modalTemplate>
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/50 backdrop-blur-sm transition-opacity"
    (click)="onOverlayClick($event)"
    (keydown)="onKeyDown($event)"
    tabindex="-1"
  >
    <div
      class="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 overflow-hidden transform transition-all"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <h2 class="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <i class="fas fa-edit text-blue-600"></i>
          Editar Publicación
        </h2>
        <button
          type="button"
          class="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-2 rounded-full transition-colors focus:outline-none"
          (click)="onClose()"
          [disabled]="isSubmitting"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Content -->
      <div class="p-6 space-y-5">
        <!-- Content Editor -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Contenido</label>
          <div class="relative">
            <textarea
              [(ngModel)]="editedContent"
              class="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none resize-none text-gray-800 transition-all"
              rows="5"
              placeholder="¿Qué estás pensando?"
              maxlength="5000"
              [disabled]="isSubmitting"
              #contentTextarea
            ></textarea>
            <div class="absolute bottom-3 right-3 text-xs text-gray-400 font-medium">
              {{ editedContent.length }}/5000
            </div>
          </div>
        </div>

        <!-- Tags Editor -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Etiquetas</label>

          <!-- Tag Input -->
          <div class="flex items-center gap-2 mb-3">
            <div class="relative flex-1">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span class="text-gray-400 font-medium">#</span>
              </div>
              <input
                type="text"
                [(ngModel)]="tagInput"
                (keydown)="onTagKeyDown($event)"
                class="w-full pl-8 pr-3 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm transition-all"
                placeholder="Añadir etiqueta (presiona Enter)"
                maxlength="20"
                [disabled]="isSubmitting"
                #tagInputRef
              />
            </div>
            <button
              type="button"
              (click)="addTag()"
              class="px-4 py-2 bg-blue-50 text-blue-600 font-medium text-sm rounded-lg hover:bg-blue-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="!tagInput.trim() || isSubmitting || editedTags.length >= 10"
            >
              Añadir
            </button>
          </div>

          <!-- Tags List -->
          <div class="flex flex-wrap gap-2" *ngIf="editedTags.length > 0">
            <span
              *ngFor="let tag of editedTags; let i = index; trackBy: trackByIndex"
              class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
            >
              #{{ tag }}
              <button
                type="button"
                (click)="removeTag(i)"
                class="ml-1.5 inline-flex items-center justify-center w-4 h-4 rounded-full text-blue-400 hover:bg-blue-200 hover:text-blue-600 focus:outline-none transition-colors"
                [disabled]="isSubmitting"
              >
                <i class="fas fa-times text-[10px]"></i>
              </button>
            </span>
          </div>

          <!-- Tag limit info -->
          <div
            class="mt-2 flex items-center gap-1.5 text-xs text-gray-500"
            *ngIf="editedTags.length >= 8"
          >
            <i class="fas fa-info-circle text-blue-500"></i>
            <span>Máximo {{ editedTags.length }}/10 etiquetas</span>
          </div>
        </div>

        <!-- Info Notice -->
        <div class="bg-blue-50/50 border border-blue-100 rounded-lg p-3 flex items-start gap-2.5">
          <i class="fas fa-info-circle text-blue-500 mt-0.5"></i>
          <p class="text-xs text-blue-800 leading-relaxed">
            Las publicaciones editadas mostrarán un indicador de "editado" para mantener la
            transparencia con otros usuarios.
          </p>
        </div>
      </div>

      <!-- Footer -->
      <div
        class="px-6 py-4 border-t border-gray-100 bg-gray-50 flex items-center justify-end gap-3"
      >
        <button
          type="button"
          (click)="onClose()"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
          [disabled]="isSubmitting"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="onSave()"
          [disabled]="!editedContent.trim() || isSubmitting"
          class="px-5 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          <i class="fas fa-check" *ngIf="!isSubmitting"></i>
          <i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i>
          {{ isSubmitting ? 'Guardando...' : 'Guardar cambios' }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
